/**
 * switch筛选判断名称做缩略
 * FiltersName过滤名称
 */
const filtersName = (value) => {
  if (value === '父亲') return '父';
  if (value === '母亲') return '母';
  if (value === '儿子') return '子';
  return '女';
};
export { filtersName };



// WEBPACK FOOTER //
// ./src/components/FiltersName/index.js